import { monitor } from '@datadog/browser-core';
import { getViewportDimension, initViewportObservable } from '../../browser/viewportObservable';
export function startDisplayContext(hooks, configuration) {
  var viewport;
  // Use requestAnimationFrame to delay the calculation of viewport dimensions until after SDK initialization, preventing long tasks.
  var animationFrameId = requestAnimationFrame(monitor(function () {
    viewport = getViewportDimension();
  }));
  var unsubscribeViewport = initViewportObservable(configuration).subscribe(function (viewportDimension) {
    viewport = viewportDimension;
  }).unsubscribe;
  hooks.register(0 /* HookNames.Assemble */, function (_ref) {
    var eventType = _ref.eventType;
    return {
      type: eventType,
      display: viewport ? {
        viewport: viewport
      } : undefined
    };
  });
  return {
    stop: function stop() {
      unsubscribeViewport();
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    }
  };
}